import React, { useState, useEffect, } from "react"
import Paper from '@material-ui/core/Paper'
import Button from '@material-ui/core/Button'
import SaveIcon from '@material-ui/icons/Save'
import axios from 'axios'
import { useSelectedSOPs, creatorType, setCreatorType , setOpenPlan, setDocs} from '../../redux/plan'
import { useRoles, useName, useToken } from '../../redux/auth'
import { ButtonGroup } from "@material-ui/core"
import DeleteIcon from '@material-ui/icons/Delete'
import {api, getAttachments} from '../../modules/db'
import { setOpenDialog, setChanges, setRedirectToDocs } from '../../redux/navigation'
import Auto from '../../components/autotags'
import { makeStyles, } from '@material-ui/core/styles'
import UploadFile from '../uploadfiledialog'
import DocEditor from './DocEditor'
import SopEditor from './SopEditor'
import CCPEditor from "./CCPEditor"
import HazardStepsEditor from "./HazardStepsEditor"
import HazardsInputsEditor from "./HazardsInputsEditor"
import { validate } from "./utils"
import NewTagDialog from '../newtagdialog'
import { theme } from "../../theme";

const btnColor = theme.colors.secondary
const btnTextColor = 'white'

const useStyles = makeStyles((theme) => ({
    upperBtn: {
        backgroundColor: btnColor,
        color: btnTextColor,
    },
}))

export const editorType = {
    doc: 'Doc',
    sop: 'SOP',
    ccp: 'CCP',
    hs : 'hs',
    hi : 'Hazards Inputs',
}

const Creator =  () => {
    const classes = useStyles()
    const token = useToken()
    const [attachments, setAttachments] = useState({})
    useEffect( () => {
        async function getAttach(){
            const att = await getAttachments(token)
            setAttachments(att)
        }
        setRedirectToDocs(false)
        getAttach()
    }, [])
    
    const doctype = creatorType()

    const initialData = doctype === editorType.sop ? {
        title: "",
        frequency: "",
        verificationandrecordkeeping: "",
        humantags: {
            AR: [],
            LOC: [],
            DOC: [],
            PR: [],
            ING: [],
            PRS: [],
            EQU: [],
            PAC: []
        },
        type: "proposal",
    }
    :
    {
        title: "",
        humantags: {
            AR: [],
            LOC: [],
            DOC: [],
            PR: [],
            ING: [],
            PRS: [],
            EQU: [],
            PAC: []
        },
    }

    const [uploadOpen, setUploadOpen] = useState(false)
    const [activeSection, setActiveSection] = useState('records')
    const [sopState, setSopState] = useState(initialData)
    const sops = useSelectedSOPs()
    const roles= useRoles()
    const name = useName()
    const [openTagDialog, setOpenTagDialog] = useState(false)

    
    const handleClear = () => {
        setOpenDialog(
            {
              open:true, 
              txt:'You are about to CLEAR all fields, are you sure?',
              neg : handleDialogNeg,
              pos : handleDialogPos
            }
        )
        
    }
   
    const handleFormChange = (event) => {
        setChanges(true)
        let res = {...sopState}
        
        res[event.target.id]=event.target.value
        if(!res["biological_hazard"]){           
            let masterDoc = res["masterDoc"]?res["masterDoc"]:"";
            let typeOfDoc = res["typeOfDoc"]?res["typeOfDoc"]:"";
            let documentKey = res["documentKey"]?res["documentKey"]:"";
            let name = res["name"]?res["name"]:"";
            res["title"]=masterDoc+"-"+typeOfDoc+"-"+documentKey+" "+name;
        }
        setSopState(res)
    }
    const handleTagsChange = (event, sop, setSopState) => {
        setChanges(true)
        let res = {...sop}
        if(!res.hasOwnProperty('humantags')){
            res['humantags']={}
        } else{
            res.humantags[event.target.id]=event.target.value.split(',') 
        }
        setSopState(res)
    }

    const upTags = (tag, val) => {
        console.log(val)
        setChanges(true)
        let res = {...sopState}
        if(!res.hasOwnProperty('humantags')){
            res['humantags']={}
        } else{
            res.humantags[tag]=val 
        }
        setSopState(res)
    }

    

    const handleSaveClick = async ( sop ) => {
        const res = validate(sopState, roles, name, doctype)
        const empt = res.empty
        console.log(doctype)
        if(doctype=="Doc"){
            empt.length === 0 ? 
                    docProcess(res.newSop) :
                        alert('You need to fill the following fields:   \n' + empt.join(', \n')) 
        }else{
            empt.length === 0 ? 
                    SaveProcess(res.newSop) :
                        alert('You need to fill the following fields:    \n' + empt.join(', \n'))
        }
        /*switch(doctype){
            case editorType.doc:
                empt.length === 0 ? 
                    docProcess(res.newSop) :
                        alert('You need to fill the following fields:   \n' + empt.join(', \n'))
                
            default:
                empt.length === 0 ? 
                    SaveProcess(res.newSop) :
                        alert('You need to fill the following fields:    \n' + empt.join(', \n'))
        } */
    }
    
    const SaveProcess = async (newSop) => {
        let toSave = {... newSop}
        roles.includes('admin') ? toSave['type']='approved' : toSave['type']='proposal'
        toSave['writer']=name
        toSave['status']=toSave.type
        setSopState(initialData)
        const res = await saveSOP(toSave, toSave.doctype)
        setRedirectToDocs(true)
        setOpenPlan(false)
        setDocs(false)
    }
    const docProcess = async (newSop) => {
        var toSave = { ...newSop }
        roles.includes('admin') ? toSave['type']='approved' : toSave['type']='proposal'
        toSave['writer']=name
        toSave['status']=toSave.type
        const res = await saveSOP(toSave, 'Doc')
    }
    const saveSOP = async (doc, type) =>  {
        doc.updated = new Date()
        const res = await axios.post(
          `${api}/sopsqav2`, 
          doc, 
          {
              headers: { Authorization: `Bearer ${token}` }
          },
        )
        alert(`Your ${type} was sucessfully saved`)
        setChanges(false)
        return res.data
    }

    const handleDialogNeg = () => {
        setOpenDialog({
          open:false, 
          txt:'',
          neg:null,
          pos:null
        })
      }
      const handleDialogPos = () => {
        setOpenDialog({
          open:false, 
          txt:'',
          neg:null,
          pos:null
        })
        setSopState(initialData)
        setRedirectToDocs(true)
        setOpenPlan(false)
        setDocs(false)
      }
    
    const lowerBtns = () => (
        <ButtonGroup
            style={{
                margin:20,
                display: 'flex',
                justifyContent: 'center',
            }}
        >
            <Button
                variant="contained"
                size="large"
                startIcon={<SaveIcon />}
                onClick={() => { 
                    handleSaveClick(
                        sopState, 
                        sops
                    )
                }}
                className={classes.upperBtn}
            >
                Save
            </Button>
            <Button
                variant="contained"
                size="large"
                startIcon={<SaveIcon />}
                onClick={() => { 
                    setOpenTagDialog(true)
                }}
                className={classes.upperBtn}
            >
                New Tag
            </Button>
            <Button
                startIcon={<DeleteIcon />}
                onClick={() => { 
                    handleClear()
                }}
                variant="contained"
                size="large"
                className={classes.upperBtn}
            >
                Clear
            </Button>
        </ButtonGroup>
    )
    

    const buttns = () => {
        return (
            <ButtonGroup
                style={{
                    margin:20,
                    display: 'flex',
                    justifyContent: 'center',
                }}
            >
                <Button
                    variant="contained"
                    size="large"
                    className={classes.upperBtn}
                    disabled={ doctype === editorType.hi }
                    onClick={ () => changeEditorType(editorType.hi)}
                >
                    Input Hazards
                </Button>
                <Button
                    variant="contained"
                    size="large"
                    className={classes.upperBtn}
                    disabled={ doctype === editorType.hs }
                    onClick={ () => changeEditorType(editorType.hs)}
                >
                    Process Hazards
                </Button>
                <Button
                    variant="contained"
                    size="large"
                    className={classes.upperBtn}
                    disabled={ doctype === editorType.ccp }
                    onClick={ () => changeEditorType(editorType.ccp)}
                >
                    CCPs
                </Button>
                <Button
                    variant="contained"
                    size="large"
                    className={classes.upperBtn}
                    disabled={ doctype === editorType.sop }
                    onClick={ () => changeEditorType(editorType.sop)}
                >
                    SOP
                </Button>
                <Button
                    variant="contained"
                    size="large"
                    className={classes.upperBtn}
                    disabled={ doctype === editorType.doc }
                    onClick={ () => changeEditorType(editorType.doc) }
                >
                    Doc
                </Button>
            </ButtonGroup>
        )
    }

    const changeEditorType = (type) => {
        setSopState(initialData)
        setCreatorType(type)
    }
    
    const currDate = new Date(). getTime() 
    
    const TagComponent = () => (
        <>
            <div 
                style={{width:'90%', marginBottom:20, paddingLeft:'10%'}}
            >
                <Auto 
                    id="AR" 
                    value={sopState.humantags ? sopState.humantags.AR : ''}
                    title={"Audit Requirements"} 
                    updateProcess={upTags} 
                    type={'Tags'}
                    tag={'AR'}
                />
            </div>
            <div 
                style={{width:'90%', marginBottom:20, paddingLeft:'10%'}}
            >
                <Auto 
                    id="LOC" 
                    value={sopState.humantags ? sopState.humantags.LOC : ''}
                    title={"Locations"} 
                    updateProcess={upTags} 
                    type={'Tags'}
                    tag={'LOC'}
                />
            </div>
            <div 
                style={{width:'90%', marginBottom:20, paddingLeft:'10%'}}
            >
                <Auto 
                    id="DOC" 
                    value={sopState.humantags ? sopState.humantags.DOC : ''}
                    title={"Document type"} 
                    updateProcess={upTags} 
                    type={'Tags'}
                    tag={'DOC'}
                />
            </div>
            <div 
                style={{width:'90%', marginBottom:20, paddingLeft:'10%'}}
            >
                <Auto 
                    id="PR" 
                    value={sopState.humantags ? sopState.humantags.PR : ''}
                    title={"Process"} 
                    updateProcess={upTags} 
                    type={'Tags'}
                    tag={'PR'}
                />
            </div>
            <div 
                style={{width:'90%', marginBottom:20, paddingLeft:'10%'}}
            >
                <Auto 
                    id="ING" 
                    value={sopState.humantags ? sopState.humantags.ING : ''}
                    title={"Ingredients"} 
                    updateProcess={upTags} 
                    type={'Tags'}
                    tag={'ING'}
                />
            </div>
            <div 
                style={{width:'90%', marginBottom:20, paddingLeft:'10%'}}
            >
                <Auto 
                    id="PRS" 
                    value={sopState.humantags ? sopState.humantags.PRS : ''}
                    title={"Process Step"} 
                    updateProcess={upTags} 
                    type={'Tags'}
                    tag={'PRS'}
                />
            </div>
            <div 
                style={{width:'90%', marginBottom:20, paddingLeft:'10%'}}
            >
                <Auto 
                    id="EQU" 
                    value={sopState.humantags ? sopState.humantags.EQU : ''}
                    title={"Equipment"} 
                    updateProcess={upTags} 
                    type={'Tags'}
                    tag={'EQU'}
                />
            </div>
            <div 
                style={{width:'90%', marginBottom:20, paddingLeft:'10%'}}
            >
                <Auto 
                    id="PAC" 
                    value={sopState.humantags ? sopState.humantags.PAC : ''}
                    title={"Packaging material type"} 
                    updateProcess={upTags} 
                    type={'Tags'}
                    tag={'PAC'}
                />
            </div>
        </>
    )

    const renderEditor = ( type ) =>{
        switch(type){
            case editorType.hi:
                return (
                    <HazardsInputsEditor
                        handleFormChange={handleFormChange}
                        setActiveSection={setActiveSection}
                        setUploadOpen={setUploadOpen}
                        sopState={sopState}
                        setSopState={setSopState}
                        upTags={upTags}
                        attachments={attachments}
                    >
                        <TagComponent />
                    </HazardsInputsEditor>
                )
            case editorType.hs:
                return(
                    <HazardStepsEditor
                        handleFormChange={handleFormChange}
                        setActiveSection={setActiveSection}
                        setUploadOpen={setUploadOpen}
                        sopState={sopState}
                        setSopState={setSopState}
                        upTags={upTags}
                        attachments={attachments}
                    >
                        <TagComponent />
                    </HazardStepsEditor>
                )
            case editorType.sop:
                return (
                    <SopEditor
                        handleFormChange={handleFormChange}
                        setActiveSection={setActiveSection}
                        setUploadOpen={setUploadOpen}
                        sopState={sopState}
                        setSopState={setSopState}
                        upTags={upTags}
                        attachments={attachments}
                    >
                        <TagComponent/>
                    </SopEditor>
                )
            case editorType.doc:
                return (
                    <DocEditor
                        handleFormChange={handleFormChange}
                        setActiveSection={setActiveSection}
                        setUploadOpen={setUploadOpen}
                        sopState={sopState}
                        setSopState={setSopState}
                        upTags={upTags}
                        attachments={attachments}
                    >
                        <TagComponent/>
                    </DocEditor>
                )
            case editorType.ccp:
                return (
                    <CCPEditor
                        handleFormChange={handleFormChange}
                        setActiveSection={setActiveSection}
                        setUploadOpen={setUploadOpen}
                        sopState={sopState}
                        setSopState={setSopState}
                        attachments={attachments}
                    >
                        <TagComponent/>
                    </CCPEditor>
                )
            default:
                return null 
        }
    }
    
    return (
        <div style={{ backgroundColor: 'transparent !important' }}>
            <NewTagDialog isOpen={openTagDialog} onClose={() => setOpenTagDialog(false)} /> 
            <UploadFile 
                isOpen={uploadOpen} 
                onClose={()=>setUploadOpen(false)} 
                section={activeSection}
                attachments={attachments}
                sopId={currDate}
                doctype={doctype}
                updateAttachments={setAttachments}
            />
            <Paper elevation={3} style={{paddingTop:50, paddingBottom:50}} >
                {buttns()}
                {renderEditor(doctype)}
                {lowerBtns()}
            </Paper>
        </div>
    )
}
export default Creator